import React from "react";
import Select from "react-select";
import _ from "lodash";

// reactstrap components
import {
    Button,
    Card,
    CardBody,
    CardFooter,
    CardTitle,
    FormGroup,
    Media,
    NavItem,
    NavLink,
    Nav,
    Pagination,
    PaginationItem,
    PaginationLink,
    Progress,
    TabContent,
    TabPane,
    Container,
    Row,
    Col
  } from "reactstrap";

  import HowItWorks from "../Common/HowItWorks";
  import StudentPricing from "../Common/StudentPricing";
  import Faq from "../Common/FaqDesktop";

  
  const DesktopView = (props)=>{
    let userType,action,actionType;
    ([userType,action] = ["student","how-it-works"]);

    const {match} = props;

    if(!_.isEmpty(match.params )){
        ({userType,action:actionType} = match.params);
        action  = (actionType !== undefined) ? actionType:action;
    }
    //console.log(action);
    

    let viewTab = "1";
    //Default view
    const [vTabs,setVTabs] = React.useState(viewTab);

    switch(action){
        case "how-it-works":viewTab = "1";
                            break;
        case "pricing":     viewTab = "2";
                            break;
        case "faq":         viewTab = "3";
                             break;

    }
    
    /*THIS IS WHERE I UDPATE THE COMPONENT */
    if(vTabs !== viewTab){
        setVTabs(viewTab)
    }
    
    const viewPage = (view)=>{
        return props.history.push(`/storage/how-it-works/${userType}/${view}`)
    }

    const isStudent = (userType === "student") ? true:false;
    
    return(
        <>
            <Row>
                <Col md="12" sm="12">
                    <Row>
                        <Col md="2" sm="2" xs="4" className="d-none d-md-block">
                        <div className="nav-tabs-navigation">
                        <div className="nav-tabs-wrapper">
                            <Nav
                            className="flex-column nav-stacked"
                            role="list"
                            tabs
                            >
                                    <NavItem>
                                        <NavLink
                                        className={vTabs === "1" ? "active" : ""}
                                        onClick={() => {
                                            return viewPage("");
                                        }}
                                        >
                                        How it works
                                        </NavLink>
                                    </NavItem>
                            { 
                                <>
                                    <NavItem>
                                        <NavLink
                                        className={vTabs === "2" ? "active" : ""}
                                        onClick={() => {
                                            return viewPage("pricing");
                                        }}
                                        >
                                        Location & Pricing
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                        className={vTabs === "3" ? "active" : ""}
                                        onClick={() => {
                                            return viewPage("faq");
                                        }}
                                        >
                                        FAQ's
                                        </NavLink>
                                    </NavItem>
                                </>
                            }
                            </Nav>
                        </div>
                        </div>
                    </Col>
                        <Col md="10" sm="10" xs="8" className="d-none d-md-block">
                        {/* Tab panes */}
                        <TabContent activeTab={"vTabs" + vTabs}>
                            <TabPane tabId="vTabs1">
                                {
                                    <HowItWorks />
                                }
                            </TabPane>
                            <TabPane tabId="vTabs2">
                                <StudentPricing 
                                    {...props}
                                />
                            </TabPane>
                            <TabPane tabId="vTabs3">
                                <Faq />
                            </TabPane>
                            
                        </TabContent>
                    </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );



}

export default DesktopView;